import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Company } from "interfaces/companies";
import SanitizeHTML from "components/SanitizeHTML/SanitizeHTML";
import { Row, Typography, Tabs, Card, Empty } from "antd";
import type { TabsProps } from "antd";
import useViewport from "components/UseViewport/UseViewport";
import { Job } from "interfaces/jobs";
import { Event } from "interfaces/events";
import SingleEventBox from "containers/Events/SingelEventBox/SingleEventBox";
import SingleJobPostingBox from "containers/JobPostings/SingleJobPostingBox/SingleJobPostingBox";
import CompanyHeader from "./CompanyHeader/CompanyHeader";

const { Title } = Typography;

const SingleCompany = () => {
  const [company, setCompany] = useState<Company>();
  const [jobs, setJobs] = useState<Job[]>([]);
  const [events, setEvents] = useState<Event[]>([]);

  const { width } = useViewport();
  const breakpoint = 950;

  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    axios.get<Company>(`/companies/${id}/`).then(response => setCompany(response.data));
  }, [id]);

  useEffect(() => {
    axios.get<Job[]>(`/jobs/`).then(response => setJobs(response.data.filter(job => job.company.toString() === id)));
  }, [id]);

  useEffect(() => {
    axios
      .get<Event[]>(`/events/`)
      .then(response => setEvents(response.data.filter(event => event.company.toString() === id)));
  }, [id]);

  const getTime = (time: string) => {
    if (new Date(time).getMinutes() <= 9) return `${new Date(time).getHours()}:0${new Date(time).getMinutes()}`;
    return `${new Date(time).getHours()}:${new Date(time).getMinutes()}`;
  };

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: `Stillingsannonser`,
      children:
        jobs.length === 0 ? (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Ingen aktuelle stillingsannonser" />
        ) : (
          jobs.map(job => {
            return (
              <div key={job.id} style={{ marginBottom: "5px" }}>
                <SingleJobPostingBox job={job} />
              </div>
            );
          })
        ),
    },
    {
      key: "3",
      label: `Arrangementer`,
      children:
        events.length === 0 ? (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Ingen kommende arrangementer" />
        ) : (
          events.map(event => {
            return (
              <div key={event.id} style={{ marginBottom: "5px" }}>
                <SingleEventBox
                  id={event.id}
                  title={event.name}
                  time={getTime(event.start)}
                  date={event.start}
                  location={event.location}
                  company={event.company}
                />
              </div>
            );
          })
        ),
    },
  ];

  if (!company) return null;
  return (
    <>
      <CompanyHeader company={company} />
      <Row style={{ width: "75%", margin: "auto" }}>
        <Title level={2}>Om {company.name}</Title>
        <SanitizeHTML html={company.description} />
      </Row>
      <Card style={width < breakpoint ? { width: "95%", margin: "20px auto" } : { width: "75%", margin: "20px auto" }}>
        <Tabs centered items={items} />
      </Card>
    </>
  );
};

export default SingleCompany;
